// axiosInstance.js
import axios from 'axios';
import router from '@/router';
import { useCookies } from 'vue3-cookies';
import { useAuthStore } from '@/stores/auth';

const { cookies } = useCookies();

let baseURL = import.meta.env.VITE_API_URL;
if (window.location.host === "creatorxone.com") {
	baseURL = import.meta.env.VITE_API_URL_NO_CLOUDFLARE;
}

const axiosInstance = axios.create({
	baseURL: baseURL, // Replace with your API base URL
	headers: {
		'Content-Type': 'application/json',
	}
});

// Add a response interceptor
axiosInstance.interceptors.response.use(
	response => {
		// Check for the specific response
		if (response.data && response.data.message === 'Access denied - Invalid token' && response.data.logout && response.data.selectBranch != true) {
			// Log the user out
			handleLogout();
		}
		return response;
	},
	error => {
		// Handle other errors
		return Promise.reject(error);
	}
);

export async function handleLogout() {
	try {
		await axiosInstance.get(`login/`, {
			params: {
				action: 'logout',
				userToken: cookies.get('userToken'),
			}
		});
		// Remove the auth token cookie
		cookies.remove('userToken');
		cookies.remove('c_id');
		
		const authStore = useAuthStore(); // Adjust based on your store setup
		if (authStore) {
			authStore.clearAuthData(); // Clear token and other auth data from Pinia
			if (typeof authStore.initialize === 'function') {
				await authStore.initialize(); // Ensure the store fetches user data with the new token
			}
		}
		// Redirect to the login page
		router.push('/');
	} catch (error) {
		console.error("Error during logout:", error);
	}
}

export default axiosInstance;
